import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { TextField, Button, Typography, Container, Grid } from '@mui/material';
import { db } from '../firebaseConfig';

const ServiceUploader = () => {
  const [serviceTitle, setServiceTitle] = useState('');
  const [objective, setObjective] = useState('');
  const [tecnicasDeTratamiento, setTecnicasDeTratamiento] = useState([]);
  const [especificacionesAcelerador, setEspecificacionesAcelerador] = useState({
    modelo: '',
    caracteristicas: []
  });
  const [servicios, setServicios] = useState({
    consultas: [],
    radio_terapia_tecnicas: []
  });
  const [programasEspeciales, setProgramasEspeciales] = useState([]);
  const [educacionMedicaContinua, setEducacionMedicaContinua] = useState({
    nombre: '',
    descripcion: '',
    detalles: []
  });
  const [loading, setLoading] = useState(false);

  const handleUpload = async () => {
    setLoading(true);

    const serviceData = {
      nombre: serviceTitle,
      objetivo: objective,
      tecnicas_de_tratamiento: tecnicasDeTratamiento,
      especificaciones_acelerador_lineal: especificacionesAcelerador,
      servicios: servicios,
      programas_especiales: programasEspeciales,
      educacion_medica_continua: educacionMedicaContinua
    };

    try {
      await addDoc(collection(db, 'services'), serviceData);
      alert('Servicio guardado con éxito');
      setServiceTitle('');
      setObjective('');
      setTecnicasDeTratamiento([]);
      setEspecificacionesAcelerador({ modelo: '', caracteristicas: [] });
      setServicios({ consultas: [], radio_terapia_tecnicas: [] });
      setProgramasEspeciales([]);
      setEducacionMedicaContinua({ nombre: '', descripcion: '', detalles: [] });
    } catch (error) {
      console.error('Error al guardar el servicio:', error);
      alert('Hubo un error al guardar el servicio.');
    } finally {
      setLoading(false);
    }
  };

  // Funciones auxiliares para manejar cambios en campos específicos
  const handleAddTecnica = () => {
    setTecnicasDeTratamiento([...tecnicasDeTratamiento, { nombre: '', descripcion: '' }]);
  };

  const handleAddCaracteristicaAcelerador = () => {
    setEspecificacionesAcelerador({
      ...especificacionesAcelerador,
      caracteristicas: [...especificacionesAcelerador.caracteristicas, '']
    });
  };

  const handleAddConsultaServicio = () => {
    setServicios({ ...servicios, consultas: [...servicios.consultas, ''] });
  };

  const handleAddRadioTerapiaTecnica = () => {
    setServicios({ ...servicios, radio_terapia_tecnicas: [...servicios.radio_terapia_tecnicas, ''] });
  };

  const handleAddProgramaEspecial = () => {
    setProgramasEspeciales([
      ...programasEspeciales,
      { nombre: '', descripcion: '', detalles: [] }
    ]);
  };

  const handleAddDetalleEducacion = () => {
    setEducacionMedicaContinua({
      ...educacionMedicaContinua,
      detalles: [...educacionMedicaContinua.detalles, '']
    });
  };

  return (
    <Container maxWidth="md">
      <Typography variant="h4" gutterBottom>Subir Servicio Detallado</Typography>

      <TextField
        label="Título del Servicio"
        variant="outlined"
        fullWidth
        margin="normal"
        value={serviceTitle}
        onChange={(e) => setServiceTitle(e.target.value)}
      />

      <TextField
        label="Objetivo"
        variant="outlined"
        fullWidth
        margin="normal"
        multiline
        rows={4}
        value={objective}
        onChange={(e) => setObjective(e.target.value)}
      />

      {/* Sección de Técnicas de Tratamiento */}
      <Typography variant="h5" gutterBottom>Técnicas de Tratamiento</Typography>
      {tecnicasDeTratamiento.map((tecnica, index) => (
        <Grid container spacing={2} key={index}>
          <Grid item xs={6}>
            <TextField
              label={`Nombre de Técnica ${index + 1}`}
              variant="outlined"
              fullWidth
              value={tecnica.nombre}
              onChange={(e) => {
                const updated = [...tecnicasDeTratamiento];
                updated[index].nombre = e.target.value;
                setTecnicasDeTratamiento(updated);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Descripción"
              variant="outlined"
              fullWidth
              multiline
              rows={2}
              value={tecnica.descripcion}
              onChange={(e) => {
                const updated = [...tecnicasDeTratamiento];
                updated[index].descripcion = e.target.value;
                setTecnicasDeTratamiento(updated);
              }}
            />
          </Grid>
        </Grid>
      ))}
      <Button onClick={handleAddTecnica} variant="outlined" style={{ marginTop: '10px' }}>Agregar Técnica</Button>

      {/* Sección de Especificaciones del Acelerador Lineal */}
      <Typography variant="h5" gutterBottom>Especificaciones del Acelerador Lineal</Typography>
      <TextField
        label="Modelo"
        variant="outlined"
        fullWidth
        margin="normal"
        value={especificacionesAcelerador.modelo}
        onChange={(e) => setEspecificacionesAcelerador({ ...especificacionesAcelerador, modelo: e.target.value })}
      />
      {especificacionesAcelerador.caracteristicas.map((caracteristica, index) => (
        <TextField
          key={index}
          label={`Característica ${index + 1}`}
          variant="outlined"
          fullWidth
          margin="normal"
          value={caracteristica}
          onChange={(e) => {
            const updated = [...especificacionesAcelerador.caracteristicas];
            updated[index] = e.target.value;
            setEspecificacionesAcelerador({ ...especificacionesAcelerador, caracteristicas: updated });
          }}
        />
      ))}
      <Button onClick={handleAddCaracteristicaAcelerador} variant="outlined" style={{ marginTop: '10px' }}>Agregar Característica</Button>

      {/* Sección de Servicios */}
      <Typography variant="h5" gutterBottom>Servicios</Typography>
      <Typography variant="h6">Consultas</Typography>
      {servicios.consultas.map((consulta, index) => (
        <TextField
          key={index}
          label={`Consulta ${index + 1}`}
          variant="outlined"
          fullWidth
          margin="normal"
          value={consulta}
          onChange={(e) => {
            const updated = [...servicios.consultas];
            updated[index] = e.target.value;
            setServicios({ ...servicios, consultas: updated });
          }}
        />
      ))}
      <Button onClick={handleAddConsultaServicio} variant="outlined" style={{ marginTop: '10px' }}>Agregar Consulta</Button>

      <Typography variant="h6">Técnicas de Radioterapia</Typography>
      {servicios.radio_terapia_tecnicas.map((tecnica, index) => (
        <TextField
          key={index}
          label={`Técnica ${index + 1}`}
          variant="outlined"
          fullWidth
          margin="normal"
          value={tecnica}
          onChange={(e) => {
            const updated = [...servicios.radio_terapia_tecnicas];
            updated[index] = e.target.value;
            setServicios({ ...servicios, radio_terapia_tecnicas: updated });
          }}
        />
      ))}
      <Button onClick={handleAddRadioTerapiaTecnica} variant="outlined" style={{ marginTop: '10px' }}>Agregar Técnica</Button>

      {/* Botón para guardar */}
      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleUpload}
        disabled={loading}
        style={{ marginTop: '20px' }}
      >
        {loading ? 'Guardando...' : 'Guardar Servicio'}
      </Button>
    </Container>
  );
};

export default ServiceUploader;
